<template>
  <Card class="card-wrap">
    <!-- body的点击区域 -->
    <!-- <section v-show="isCommunity"> -->
    <!-- <section v-show="!isCommunity" @click="onWrapClick"> -->
    <section @click="onWrapClick">
      <!-- 头部 -->
      <div class="card-header">
        <!-- 支部名称 -->
        <div class="orgname">{{ party.zoneName }}</div>
        <!-- 管理人 -->
        <div  class="org-person">
          <i class="iconfont icon-shequfuzeren"></i>
          <span class="org-person-name">
            {{ party.typeName ? party.typeName : "小区负责人" }}：{{
            party.clerkName
            }}
          </span>
        </div>
        <!-- <template v-if="isCommunity">
          <div class="xq-title" @click="onWrapClick">小区详情></div>
        </template> -->

        <!-- 支部类型 -->
        <div class="org-type" v-if="party.orgTypeName">{{ party.orgTypeName }}</div>
      </div>

      <!-- 底部选项 -->
      <div class="card-footer">
        <!-- 活动 -->
        <div class="card-footer_item">
          <i class="iconfont icon-huodong-"></i>
          <section>
            <div class="card-footer_item_title">活动</div>
            <div class="card-footer_item_number">{{ party.activityCount }}个</div>
          </section>
        </div>
        <!-- 上报 -->
        <div class="card-footer_item">
          <i class="iconfont icon-shangbao-"></i>
          <section>
            <div class="card-footer_item_title">上报</div>
            <div class="card-footer_item_number">{{ party.reportEventCount }}个</div>
          </section>
        </div>
        <!-- 办理 -->
        <div class="card-footer_item">
          <i class="iconfont icon-toupiao1"></i>
          <section>
            <div class="card-footer_item_title">投票</div>
            <div class="card-footer_item_number">{{ party.voteCount }}个</div>
          </section>
        </div>
      </div>
      <!-- <div v-if="isCommunity" class="card-bottom"> -->
        <!-- <div class="lyd">楼宇 31栋</div> -->
        <!-- <div class="lyxq" @click="onDetailClick">楼宇列表></div> -->
      <!-- </div> -->
    </section>
    <!-- 成员数 -->
    <div class="member-wrap">
      <div class="member-title">成员数</div>
      <div class="member-number">{{ party.userCount }}</div>
    </div>
    <!-- 操作选项 -->
    <div class="iconfont icon-chushaixuanxiang delete" @click="onDelete"></div>
  </Card>
</template>

<script>
export default {
  components: {},
  props: {
    party: {
      type: Object,
      default() {
        return {};
      }
    },
    isCommunity: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    onWrapClick() {
      this.$emit("on-click");
    },
    onDetailClick() {
      this.$emit("on-detail-click");
    },
    onDelete() {
      this.$emit("on-delete");
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.card-header {
  .flex(center, center, @flexDirection:column);
  min-height: 190px;
}
.orgname {
  color: #4b4b4b;
  font-size: 24px;
  max-width: 70%;
}
.org-person {
  margin: 10px 0;
}
.org-person-name {
  font-size: 16px;
  font-weight: bold;
}
.org-type {
  color: #fff;
  background-color: #ff7744;
  padding: 4px 10px;
  border-radius: 4px;
}
.icon-shequfuzeren {
  color: #de200f;
  // 图标的裁剪问题
  font-size: 22px;
  vertical-align: middle;
}
.card-footer {
  .flex(center, center);
}
.card-footer_item {
  .flex(center);
  padding: 0 26px;
  border-right: 1px solid #e7e7e7;
  .iconfont {
    font-size: 28px;
    margin-right: 20px;
  }
  &:last-child {
    border-right: none;
  }
  .icon-huodong- {
    color: #feae00;
  }
  .icon-shangbao- {
    color: #55ddb9;
  }
  .icon-toupiao1 {
    color: #3fa0ff;
    // 图标的裁剪问题
    font-size: 36px;
  }
}
.card-footer_item_title {
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
}
.card-footer_item_number {
  font-size: 26px;
  color: #333;
  white-space: nowrap;
}
/* 成员数 */
.member-wrap {
  .flex(center, @flexDirection:column);
  position: absolute;
  top: 0;
  left: 20px;

  width: 52px;
  height: 85px;
  background-color: #00aeff;
  color: #fff;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    left: -10%;
    bottom: -38%;
    width: 120%;
    height: 50%;
    background-color: #fff;
    border-radius: 50%;
  }
}
.member-title {
  font-size: 14px;
  margin-top: 15px;
}
.member-number {
  font-size: 16px;
}
.delete {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 18px;
  color: #ccc;
  cursor: pointer;
}
.xq-title {
  font-weight: bold;
  color: #ff7b44;
  padding-top: 20px;
  cursor: pointer;
}
.card-bottom {
  .flex(center);
  justify-content: space-between;
  border-top: 1px solid #e7e7e7;
  margin-top: 20px;
  padding: 15px 0 0;
  .lyxq {
    font-weight: bold;
    color: #ff7b44;
    cursor: pointer;
  }
}
</style>
